import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ConstantService, SessionStorage } from '../../services/constant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { ModificationCommonService } from '../../services/modification-common.service';
import { SessionStorageService } from '../../services/session-storage.service';

declare function segmentModificationRedirection(url:string): any;

@Component({
  selector: 'app-success',
  imports: [],
  templateUrl: './success.component.html',
  styleUrl: './success.component.less'
})

export class SuccessComponent {
  btnLoader = false;
  h4_context = 'Hang Tight!';
  p_context_1 = 'Your NSE & BSE Derivatives segments will be activated within 48 hours.<br/>Stay tuned—your F&O trading journey is about to begin with 5paisa FNO360.'
  // p_context_2 = ``
  constructor(
      private activatedRoute: ActivatedRoute,
      private sessionStorageService : SessionStorageService,
  ) {
      activatedRoute.queryParams.subscribe((params:any) => {
          if(params['header']){
            this.h4_context = params.header,
            this.p_context_1 = params.msgLine1
          }
      });
  }

    ngOnInit() {
    let subSource = this.sessionStorageService.getItem(SessionStorage.subSource)?.toUpperCase() ||'';
    if(subSource == 'FLUTTER_ANDROID' || subSource == 'FLUTTER_IOS'){
         setInterval(() => {
        segmentModificationRedirection(window.location.href);
      }, 3000);  
    }else{
        setInterval(() => {
       const returnURL = this.sessionStorageService.getItem(SessionStorage.returnURL)
        if(returnURL)
       { window.location.href = returnURL }
    else {
    }
      }, 2000);  
    
    }
  }

  isMobile(): boolean {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod/i.test(ua);
}
}
